import { module } from 'stereomodularjs'

import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, EffectFade, Controller, Autoplay } from 'swiper/modules';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, A11y, EffectFade, Controller, Autoplay]);

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        let hasController = false
        this.sliderChildImageEl = document.querySelector(this.el.dataset.sliderImage)
        this.sliderChildBgEl = document.querySelector(this.el.dataset.sliderBg)

        this.params = {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            grabCursor: true,
            touchEventsTarget: 'container',
            speed: 800,

            // If we need pagination
            pagination: {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            },

            // And if we need scrollbar
            scrollbar: {
                el: this.el.querySelector('.swiper-scrollbar'),
                draggable: true,
            },

            // a11y
            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
            },
        }

        this.typeSlider = this.el.dataset.type

        // Home show slider
        if (this.typeSlider == 'show') {

            this.params.navigation = false;
            this.params.slidesPerView = 'auto';

            // create child sliders
            if (this.sliderChildImageEl && this.sliderChildBgEl) {
                hasController = true
                this.params.pagination = false
                this.sliderChildImage = new Swiper(this.sliderChildImageEl, this.params);
                this.sliderChildBg = new Swiper(this.sliderChildBgEl, this.params);
            }

            this.params.effect = 'fade'
            // Add pagination to the main show slider
            this.params.pagination = {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            }

            this.params.navigation = {
                nextEl: document.querySelector('.main-slider-next'),
                prevEl: document.querySelector('.main-slider-prev'),
            }

            this.params.autoplay = {
                delay: 6000,
                disableOnInteraction: true,
            }
        }

        this.slider = new Swiper(this.el, this.params)

        // if show slider (fold homepage)
        if (hasController) {
            this.params.pagination = false

            this.slider.controller.control = [
                this.sliderChildImage,
                this.sliderChildBg,
            ]

            this.sliderChildImage.controller.control = [
                this.slider,
                this.sliderChildBg,
            ]
        }

        this.pauseAutoplay()
    }

    pauseAutoplay() {
        if (this.slider) {
            this.slider.autoplay.pause()
        }
        if (this.sliderChildImage) {
            this.sliderChildImage.autoplay.pause()
        }
        if (this.sliderChildBg) {
            this.sliderChildBg.autoplay.pause()
        }
    }

    resumeAutoplay() {
        if (this.slider) {
            this.slider.autoplay.resume()
        }
        if (this.sliderChildImage) {
            this.sliderChildImage.autoplay.resume()
        }
        if (this.sliderChildBg) {
            this.sliderChildBg.autoplay.resume()
        }
    }

    destroy() {
        if (this.slider) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}